var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("help-hub-breadcrumb", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading"
          }
        ],
        key: _vm.breadCrumbComponentKey,
        staticClass: "profile-page",
        attrs: { "is-self-service": false, title: _vm.breadcrumbTitle }
      }),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-overlay") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading"
            }
          ]
        },
        [
          _c("help-hub-user-profile", {
            key: _vm.componentKey,
            attrs: {
              "user-id": _vm.userName,
              "current-user-access-token": _vm.currentToken,
              "is-helphub-app": true,
              title: "Profile Page",
              "show-user-profile": _vm.showUserProfile,
              "scroll-to-devices": _vm.scrollToDevices,
              "open-team-defaults-modal": _vm.openTeamDefaultsModal,
              "scroll-to-delegates": _vm.scrollToDelegates,
              "display-name": _vm.displayName,
              email: _vm.email
            },
            on: {
              onProfilePageComponentSuccess: _vm.onProfilePageComponentSuccess,
              onTeamDataSuccess: _vm.onTeamDataSuccess
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28d27d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d27d1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ProfilePage.vue
// module id = null
// module chunks = 